(function (angular, document) {
  "use strict";

  var MIN_FRACTION_OF_VIEWPORT_USED_BY_ELEMENT = 0.75;

  angular.module("Toyota.Services").service("ScrollIntoView", [
    "SmoothScrollTo",
    function (SmoothScrollTo) {
      // Backported from scroll-into-view.ts

      function getDocumentHeight() {
        return Math.max(
          document.body.scrollHeight,
          document.body.offsetHeight,
          document.documentElement.clientHeight,
          document.documentElement.scrollHeight,
          document.documentElement.offsetHeight
        );
      }

      function getViewportHeight() {
        return (
          window.innerHeight ||
          document.documentElement.clientHeight ||
          document.getElementsByTagName("body")[0].clientHeight
        );
      }

      function segmentOverlap(segment1, segment2) {
        var doSegmentsOverlap = segment1.start <= segment2.end && segment2.start <= segment1.end;

        if (!doSegmentsOverlap) {
          return null;
        }

        return {
          start: Math.max(segment1.start, segment2.start),
          end: Math.min(segment1.end, segment2.end),
        };
      }

      function segmentContainsPoint(segment, point) {
        return point >= segment.start && point <= segment.end;
      }

      function segmentOverlapSize(segment1, segment2) {
        var intersection = segmentOverlap(segment1, segment2);
        return intersection ? intersection.end - intersection.start : 0;
      }

      function scrollIntoView($el) {
        var el = $el.get(0);
        var viewportTop = window.pageYOffset;
        var elementTop = el.offsetTop;

        var viewportHeight = getViewportHeight();
        var elementHeight = el.offsetHeight;
        var elementBottom = elementTop + elementHeight;

        var viewportSegment = { start: viewportTop, end: viewportTop + viewportHeight };
        var elementSegment = { start: elementTop, end: elementBottom };

        var isElementTopVisible = segmentContainsPoint(viewportSegment, elementTop);
        var isElementBottomVisible = segmentContainsPoint(viewportSegment, elementBottom);
        var fractionOfViewportUsedByElement = segmentOverlapSize(viewportSegment, elementSegment) / viewportHeight;

        var endYOffset = Math.ceil(Math.min(elementTop, getDocumentHeight() - viewportHeight));

        if (
          !isElementTopVisible ||
          (isElementTopVisible &&
            fractionOfViewportUsedByElement < MIN_FRACTION_OF_VIEWPORT_USED_BY_ELEMENT &&
            !isElementBottomVisible)
        ) {
          SmoothScrollTo(endYOffset);
        }
      }

      return scrollIntoView;
    },
  ]);
})(window.angular, window.document);
